import { render, staticRenderFns } from "./ListaVentasRemision.vue?vue&type=template&id=c12e4244&"
import script from "./ListaVentasRemision.vue?vue&type=script&lang=js&"
export * from "./ListaVentasRemision.vue?vue&type=script&lang=js&"
import style0 from "./ListaVentasRemision.vue?vue&type=style&index=0&id=c12e4244&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports